<template>
  <v-app style="background-color: #f8f9fb">
    <v-container
      style="background-color: #eee"
      id="mensageria-automacao"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-robot"
            title="Mensageria Automações"
            color="rgb(71 130 180)"
            style="margin-top: 60px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <!-- Formulário -->
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <!-- Data inicio -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Data inicio</span>
                  <v-menu
                    v-model="isDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="automacao.dataInicio"
                        label="Data inicio"
                        dense
                        solo-inverted
                        readonly
                        :rules="[(v) => !!v || 'Campo obrigatorio']"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="localSelectedDateISO"
                      @input="handleDateSelection"
                    />
                  </v-menu>
                </v-col>

                <!-- Horario -->
                <v-col cols="12" sm="2" class="py-0">
                  <span>Horario</span>
                  <v-text-field
                    type="time"
                    v-model="automacao.horario"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Tipo -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Tipo</span>
                  <v-select
                    :items="['Validação de plano', 'Óbitos']"
                    v-model="automacao.tipo"
                    label="Tipo"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Empresa -->
                <v-col cols="12" sm="3" class="py-0">
                  <span>Empresa</span>
                  <v-select
                    :items="filteredEmpresas"
                    v-model="automacao.empresa"
                    label="Empresa"
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                  />
                </v-col>

                <!-- Template -->
                <v-col cols="12" sm="6" class="py-0">
                  <span>Template</span>
                  <v-select
                    v-model="selectedTemplateId"
                    :items="activeTemplates"
                    item-text="name"
                    item-value="_id"
                    dense
                    solo-inverted
                    :loading="loadingTemplates"
                    :disabled="!automacao.empresa"
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                    @change="onTemplateSelectChange"
                  />
                </v-col>
                <!-- Status -->
                <v-col cols="12" sm="2" class="py-0">
                  <span>Status</span>
                  <v-switch
                    v-model="automacao.status"
                    item-text="text"
                    item-value="value"
                    dense
                    solo-inverted
                    :rules="[(v) => v !== null || 'Campo obrigatorio']"
                  />
                </v-col>
              </v-row>

              <!-- Preview e Parâmetros do Template -->
              <v-row v-if="selectedTemplate" style="margin-top: 0.5rem">
                <v-col cols="12" class="py-0">
                  <span>Pré-visualização do template</span>
                  <v-sheet
                    outlined
                    rounded
                    class="pa-4 mb-3 template-preview-sheet"
                  >
                    <div class="text--secondary text-caption mb-2">
                      O conteúdo abaixo é atualizado conforme os parâmetros são
                      preenchidos.
                    </div>
                    <div
                      class="template-preview-text"
                      style="white-space: pre-line; line-height: 1.5"
                    >
                      {{ getTemplatePreview(selectedTemplate.content) }}
                    </div>
                  </v-sheet>
                </v-col>

                <v-col
                  cols="12"
                  class="py-0"
                  v-if="extractTemplateParams(selectedTemplate.content).length"
                >
                  <div class="d-flex align-center mb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      outlined
                      color="primary"
                      @click="dialogVariaveis = true"
                    >
                      <v-icon left small>mdi-code-braces</v-icon>
                      Variáveis disponíveis
                    </v-btn>
                  </div>
                  <span>Parâmetros do template</span>
                </v-col>

                <v-col
                  v-for="(param, index) in extractTemplateParams(
                    selectedTemplate.content,
                  )"
                  :key="`${selectedTemplateId}-${param}-${index}`"
                  cols="12"
                  sm="6"
                  md="4"
                  class="py-0"
                >
                  <v-text-field
                    v-model="templateParams[index]"
                    :label="
                      templateParamLabels[index] || `Parâmetro ${index + 1}`
                    "
                    dense
                    solo-inverted
                    :rules="[(v) => !!v || 'Campo obrigatorio']"
                    @focus="templateParamEmFoco = index"
                  />
                </v-col>
              </v-row>

              <v-row style="margin-top: 0.5rem">
                <!-- Botoes -->
                <v-col cols="12" class="py-4 d-flex justify-end">
                  <v-btn
                    outlined
                    small
                    color="primary"
                    @click="limparFormulario"
                    class="mr-4"
                  >
                    <v-icon left>mdi-reload</v-icon>Limpar formulário
                  </v-btn>
                  <v-btn
                    small
                    :loading="loadingCreate"
                    :disabled="!valid"
                    :color="modeEdit ? 'warning' : 'primary'"
                    @click="salvarAutomacao(automacao)"
                  >
                    <v-icon left
                      >{{ !modeEdit ? "mdi-plus" : "mdi-reload" }}
                    </v-icon>
                    {{ !modeEdit ? "Nova automação" : "Atualizar automação" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <!-- Listagem de Automações -->
            <v-divider class="my-6"></v-divider>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="listaAutomacoes"
                  :loading="loadingLista"
                  no-data-text="Nenhuma automação encontrada"
                  no-results-text="Nenhum resultado encontrado"
                  class="elevation-0"
                >
                  <!-- EMPRESA -->
                  <template v-slot:item.empresa="{ item }">
                    <v-chip small dark :color="getEmpresa(item.empresa)">
                      {{ item.empresa }}
                    </v-chip>
                  </template>

                  <!-- DATA -->
                  <template v-slot:item.dataInicio="{ item }">
                    {{ item.dataInicio }}
                  </template>

                  <!-- TEMPLATE -->
                  <template v-slot:item.template="{ item }">
                    <div
                      class="text-truncate"
                      style="max-width: 200px"
                      :title="item.templateNome || '-'"
                    >
                      {{ item.templateNome || "-" }}
                    </div>
                  </template>

                  <!-- TIPO -->
                  <template v-slot:item.tipo="{ item }">
                    <v-chip
                      small
                      :color="getTipoColor(item.tipo)"
                      :text-color="getTipoTextColor(item.tipo)"
                    >
                      {{ item.tipo }}
                    </v-chip>
                  </template>

                  <!-- STATUS -->
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      small
                      :color="item.status ? 'green lighten-5' : 'red lighten-5'"
                      :text-color="
                        item.status ? 'green darken-3' : 'red darken-3'
                      "
                    >
                      {{ item.status ? "Ativo" : "Inativo" }}
                    </v-chip>
                  </template>

                  <!-- ACOES -->
                  <template v-slot:item.acoes="{ item }">
                    <v-btn
                      text
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="visualizarDados(item)"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>

                    <v-btn
                      text
                      small
                      color="warning"
                      v-bind="attrs"
                      v-on="on"
                      @click="editarAutomacao(item)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          small
                          :color="item.status ? 'error' : 'success'"
                          v-bind="attrs"
                          v-on="on"
                          @click="alterarStatus(item)"
                        >
                          <v-icon small>{{
                            item.status ? "mdi-pause" : "mdi-play"
                          }}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ item.status ? "Desativar" : "Ativar" }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog de Visualização de Dados -->
    <v-dialog v-model="dialogVariaveis" max-width="900px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-code-braces</v-icon>
          Variáveis disponíveis
        </v-card-title>

        <v-card-text class="pt-4">
          <div class="text-body-2 mb-4">
            Selecione um campo de parâmetro antes de inserir uma variável.
          </div>

          <v-data-table
            :headers="headersVariaveis"
            :items="variaveisDisponiveis"
            dense
            hide-default-footer
            class="elevation-0 dialog-table"
          >
            <template v-slot:item.nome="{ item }">
              <code>{{ item.nome }}</code>
            </template>

            <template v-slot:item.tipo="{ item }">
              <v-chip
                x-small
                :color="
                  item.tipo === 'Extra' ? 'blue lighten-5' : 'grey lighten-4'
                "
              >
                {{ item.tipo }}
              </v-chip>
            </template>

            <template v-slot:item.acoes="{ item }">
              <div class="d-flex justify-end">
                <v-btn
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="copiarTexto(item.nome)"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="inserirVariavelNoParametro(item.nome)"
                    >
                      <v-icon small>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Inserir</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogVariaveis = false" small>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVisualizacao" max-width="900px" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-eye</v-icon>
          Dados Enviados - {{ automacaoSelecionada?.tipo }}
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row v-if="loadingDados" class="my-12">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <p class="mt-4">Carregando dados...</p>
            </v-col>
          </v-row>

          <v-row v-else-if="dadosEnviados.length === 0" class="my-12">
            <v-col cols="12" class="text-center">
              <v-icon size="64" color="grey lighten-1"
                >mdi-information-outline</v-icon
              >
              <p class="mt-4 grey--text">Nenhum dado enviado ainda</p>
            </v-col>
          </v-row>

          <v-data-table
            v-else
            dense
            :headers="headersDados"
            :items="dadosEnviados"
            :items-per-page="10"
            class="elevation-0 dialog-table"
          >
            <template v-slot:item.dataEnvio="{ item }">
              {{ formatarDataHora(item.dataEnvio) }}
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip small :color="getStatusEnvioColor(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="exportarDados"
            :disabled="dadosEnviados.length === 0"
            small
          >
            <v-icon left>mdi-download</v-icon>
            Exportar
          </v-btn>
          <v-btn color="error" text @click="dialogVisualizacao = false" small>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Fechar </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import MensageriaService from "@/services/mensageria";
import SonaxService from "@/services/sonax";

export default {
  name: "MensageriaAutomacao",

  data: () => ({
    valid: false,
    modeEdit: false,
    loadingCreate: false,
    loadingLista: false,
    loadingDados: false,
    loadingTemplates: false,
    isHydratingAutomacao: false,
    isDatePickerOpen: false,
    localSelectedDateISO: null,
    dialogVariaveis: false,
    dialogVisualizacao: false,
    automacaoSelecionada: null,
    dadosEnviados: [],
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
    templates: [],
    selectedTemplate: null,
    selectedTemplateId: null,
    selectedTemplateNome: null,
    templateParams: [],
    templateParamEmFoco: null,
    templateParamLabels: [],

    automacao: {
      id: null,
      dataInicio: null,
      horario: null,
      tipo: null,
      empresa: null,
      status: true,
      template: null,
    },

    listaAutomacoes: [],

    empresas: [
      "CEMITERIO PREVIDA",
      "MEMORIAL PARQUE MACEIÓ",
      "PARQUE DAS FLORES",
      "PARQUE DO AGRESTE",
      "PREVIDA",
      "A FLOR DO CAFÉ",
      "CEMITERIO PREVIDA SAO MIGUEL",
    ],

    headers: [
      { text: "Data Início", value: "dataInicio", sortable: true },
      { text: "Horário", value: "horario", sortable: true },
      { text: "Tipo", value: "tipo", sortable: true },
      { text: "Empresa", value: "empresa", sortable: true },
      { text: "Template", value: "template", sortable: false },
      { text: "Status", value: "status", sortable: true },
      { text: "Ações", value: "acoes", sortable: false, align: "center" },
    ],

    headersDados: [
      { text: "Cliente", value: "nomeCliente", sortable: true },
      { text: "Telefone", value: "telefone", sortable: false },
      { text: "Data Envio", value: "dataEnvio", sortable: true },
      { text: "Status", value: "status", sortable: true },
      { text: "Mensagem", value: "mensagem", sortable: false },
    ],
    headersVariaveis: [
      { text: "Variável", value: "nome", sortable: false },
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "Exemplo", value: "exemplo", sortable: false },
      { text: "Tipo", value: "tipo", sortable: false, align: "center" },
      { text: "Ações", value: "acoes", sortable: false, align: "end" },
    ],
  }),

  computed: {
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    activeTemplates() {
      if (!this.templates || !this.templates.length) return [];

      return this.templates.filter(
        (template) => template.status_broker === "APPROVED",
      );
    },
    variaveisDisponiveis() {
      const variaveisBase = [
        {
          nome: "{{nomeCliente}}",
          descricao: "Nome do cliente",
          exemplo: "João Silva",
          tipo: "Padrão",
        },
        {
          nome: "{{contrato}}",
          descricao: "Número do contrato",
          exemplo: "MP012234",
          tipo: "Padrão",
        },
        {
          nome: "{{descricao}}",
          descricao: "Descrição do atendimento",
          exemplo: "Contrato novo",
          tipo: "Padrão",
        },
        {
          nome: "{{telefone}}",
          descricao: "Telefone do cliente",
          exemplo: "5582999999999",
          tipo: "Padrão",
        },
      ];

      const variaveisValidacao = [
        {
          nome: "{{enderecoCompleto}}",
          descricao: "Endereço completo",
          exemplo: "Rua Exemplo, 100 - Centro",
          tipo: "Extra",
        },
        {
          nome: "{{valorPlano}}",
          descricao: "Valor do plano",
          exemplo: "R$ 89,90",
          tipo: "Extra",
        },
        {
          nome: "{{diaVenc}}",
          descricao: "Dia de vencimento",
          exemplo: "10",
          tipo: "Extra",
        },
        {
          nome: "{{email}}",
          descricao: "E-mail do cliente",
          exemplo: "cliente@exemplo.com",
          tipo: "Extra",
        },
      ];

      return this.automacao.tipo === "Validação de plano"
        ? [...variaveisBase, ...variaveisValidacao]
        : variaveisBase;
    },
    telefoneEmpresa() {
      if (!this.automacao.empresa) {
        return null;
      }

      const empresaAtual = this.automacao.empresa;

      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        Previda: "558282308177",
        previda: "558282308177",
        "MEMORIAL PARQUE MACEIÓ": "558299289412",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "Memorial Parque Maceió": "558299289412",
        "Memorial Parque Maceio": "558299289412",
        "Parque das Flores": "558296411028",
        "PARQUE DAS FLORES": "558296411028",
        "CEMITERIO PREVIDA": "558000829000",
        "Cemitério Previda": "558000829000",
        "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
        "Cemitério Previda São Miguel": "558000829000",
        "PARQUE DO AGRESTE": "558000829000",
        "Parque do Agreste": "558000829000",
      };

      const normalizar = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();
      };

      if (mapeamentoEmpresas[empresaAtual]) {
        return mapeamentoEmpresas[empresaAtual];
      }

      const empresaUpper = empresaAtual.toUpperCase();
      if (mapeamentoEmpresas[empresaUpper]) {
        return mapeamentoEmpresas[empresaUpper];
      }

      const empresaNormalizada = normalizar(empresaAtual);
      for (const [key, telefone] of Object.entries(mapeamentoEmpresas)) {
        if (normalizar(key) === empresaNormalizada) {
          return telefone;
        }
      }

      if (empresaNormalizada.includes("CEMITERIO")) {
        return "558000829000";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("AGRESTE")
      ) {
        return "558000829000";
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "558282308177";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEIO")
      ) {
        return "558299289412";
      }
      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "558296411028";
      }

      console.warn(
        "Empresa não mapeada:",
        empresaAtual,
        "Sem telefone cadastrado",
      );
      return null;
    },
  },

  watch: {
    "automacao.empresa"(novaEmpresa, antigaEmpresa) {
      if (!novaEmpresa) return;
      this.templates = [];
      if (!this.isHydratingAutomacao) {
        this.selectedTemplate = null;
        this.selectedTemplateId = null;
        this.selectedTemplateNome = null;
        this.templateParams = [];
        this.templateParamLabels = [];
      }
      this.fetchTemplates();
    },
  },

  mounted() {
    this.carregarAutomacoes();
  },

  methods: {
    copiarTexto(texto) {
      navigator.clipboard
        .writeText(texto)
        .then(() => {
          this.mostrarSnackbar("Variável copiada", "success");
        })
        .catch((error) => {
          console.error("Erro ao copiar texto:", error);
          this.mostrarSnackbar("Erro ao copiar variável", "error");
        });
    },

    inserirVariavelNoParametro(variavel) {
      if (
        this.templateParamEmFoco === null ||
        this.templateParamEmFoco === undefined
      ) {
        this.mostrarSnackbar(
          "Selecione um campo de parâmetro antes de inserir a variável.",
          "warning",
        );
        return;
      }

      const valorAtual = this.templateParams[this.templateParamEmFoco] || "";
      this.$set(
        this.templateParams,
        this.templateParamEmFoco,
        `${valorAtual}${variavel}`,
      );
      this.mostrarSnackbar("Variável inserida no parâmetro", "success");
    },

    hasPermission(empresa) {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"),
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          user.roles.includes(role),
        );
        return hasAnyRequiredRole;
      }
    },

    async fetchTemplates() {
      if (!this.automacao.empresa) {
        console.warn(
          "Por favor, selecione uma empresa no filtro antes de buscar templates.",
        );
        return;
      }

      this.loadingTemplates = true;
      try {
        const response = await SonaxService.getTemplates(this.telefoneEmpresa);

        if (
          response.data &&
          !response.data.error &&
          response.data.data &&
          response.data.data.brokers &&
          response.data.data.brokers.length > 0
        ) {
          let brokerEncontrado = response.data.data.brokers.find(
            (broker) => broker.number === this.telefoneEmpresa,
          );

          if (
            !brokerEncontrado ||
            !brokerEncontrado.templates ||
            brokerEncontrado.templates.length === 0
          ) {
            brokerEncontrado = response.data.data.brokers.find(
              (broker) => broker.templates && broker.templates.length > 0,
            );
          }

          if (
            brokerEncontrado &&
            brokerEncontrado.templates &&
            brokerEncontrado.templates.length > 0
          ) {
            const brokerNumber = brokerEncontrado.number;
            this.templates = brokerEncontrado.templates.map((template) => ({
              ...template,
              brokerNumber,
            }));
            console.log("Templates carregados:", this.templates.length);
            this.sincronizarTemplateSelecionado({
              templateId: this.selectedTemplateId,
              templateNome: this.selectedTemplateNome,
              templateParams: this.templateParams,
              preservarValoresAtuais: true,
            });
          } else {
            this.templates = [];
            console.log(
              "Nenhum template encontrado para o telefone:",
              this.telefoneEmpresa,
            );
          }
        } else {
          this.templates = [];
        }
      } catch (error) {
        console.error("Erro ao buscar templates:", error);
        this.mostrarSnackbar("Erro ao buscar templates", "error");
        this.templates = [];
      } finally {
        this.loadingTemplates = false;
      }
    },

    normalizarTemplateParams(templateParams) {
      if (Array.isArray(templateParams)) {
        return [...templateParams];
      }

      if (typeof templateParams === "string" && templateParams) {
        return templateParams.split(";").filter(Boolean);
      }

      return [];
    },

    aplicarTemplateSelecionado(
      template,
      templateParams = [],
      preservarValoresAtuais = false,
    ) {
      if (!template) {
        return;
      }

      this.selectedTemplate = template;
      this.selectedTemplateId = template._id;
      this.selectedTemplateNome = template.name;

      const quantidadeParametros = this.extractTemplateParams(
        template.content,
      ).length;
      const origemValores = preservarValoresAtuais
        ? this.templateParams
        : templateParams;

      this.templateParams = Array.from(
        { length: quantidadeParametros },
        (_, index) => origemValores[index] || "",
      );
      this.templateParamLabels = new Array(quantidadeParametros).fill("");
    },

    sincronizarTemplateSelecionado({
      templateId = this.selectedTemplateId,
      templateNome = this.selectedTemplateNome,
      templateParams = [],
      preservarValoresAtuais = false,
    } = {}) {
      if (!templateId && !templateNome) {
        return false;
      }

      const template = this.activeTemplates.find(
        (item) => item._id === templateId || item.name === templateNome,
      );

      if (!template) {
        return false;
      }

      this.aplicarTemplateSelecionado(
        template,
        templateParams,
        preservarValoresAtuais,
      );
      return true;
    },

    onTemplateSelectChange(templateId) {
      if (!templateId) {
        this.selectedTemplate = null;
        this.selectedTemplateId = null;
        this.selectedTemplateNome = null;
        this.templateParams = [];
        this.templateParamLabels = [];
        return;
      }

      const template = this.activeTemplates.find(
        (item) => item._id === templateId,
      );

      if (template) {
        this.aplicarTemplateSelecionado(template, this.templateParams, true);
      }
    },

    extractTemplateParams(content) {
      if (!content) {
        return [];
      }

      const regex = /\{\{(\d+)\}\}/g;
      const params = [];
      let match;

      while ((match = regex.exec(content)) !== null) {
        params.push(match[1]);
      }

      return [...new Set(params)].sort((a, b) => a - b);
    },

    getTemplatePreview(content) {
      if (!content) {
        return "";
      }

      const parametros = this.extractTemplateParams(content);

      return content.replace(/\{\{(\d+)\}\}/g, (match, numero) => {
        const indiceParametro = parametros.findIndex(
          (parametro) => String(parametro) === String(numero),
        );

        if (indiceParametro < 0) {
          return match;
        }

        const valor = this.templateParams[indiceParametro];
        return valor && String(valor).trim() !== "" ? valor : match;
      });
    },

    handleDateSelection(date) {
      this.automacao.dataInicio = this.formatDate(date);
      this.isDatePickerOpen = false;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatarDataHora(dataHora) {
      if (!dataHora) return "-";
      const date = new Date(dataHora);
      return date.toLocaleString("pt-BR");
    },

    getEmpresa(empresa) {
      switch (empresa) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";
        default:
          return "grey";
      }
    },

    getTipoColor(tipo) {
      return tipo === "Validação de plano"
        ? "blue lighten-5"
        : "purple lighten-5";
    },

    getTipoTextColor(tipo) {
      return tipo === "Validação de plano"
        ? "blue darken-3"
        : "purple darken-3";
    },

    getStatusEnvioColor(status) {
      const cores = {
        Enviado: "success",
        Pendente: "warning",
        Erro: "error",
        Processando: "info",
      };
      return cores[status] || "grey";
    },

    async carregarAutomacoes() {
      this.loadingLista = true;
      try {
        const response = await MensageriaService.listarAutomacoes();
        this.listaAutomacoes = response.data;
      } catch (error) {
        this.mostrarSnackbar("Erro ao carregar automações", "error");
        console.error(error);
      } finally {
        this.loadingLista = false;
      }
    },

    async salvarAutomacao(automacao) {
      if (!this.$refs.form.validate()) return;

      this.loadingCreate = true;
      try {
        const payload = {
          id: automacao.id,
          dataInicio: automacao.dataInicio,
          horario: automacao.horario,
          tipo: automacao.tipo,
          empresa: automacao.empresa,
          status: automacao.status,
          templateId: this.selectedTemplateId,
          templateNome:
            this.selectedTemplate?.name || this.selectedTemplateNome || null,
          templateParams: [...this.templateParams],
        };

        await MensageriaService.salvarAutomacao(payload);

        this.mostrarSnackbar(
          this.modeEdit
            ? "Automação atualizada com sucesso!"
            : "Automação criada com sucesso!",
          "success",
        );

        this.limparFormulario();
        this.carregarAutomacoes();
      } catch (error) {
        this.mostrarSnackbar("Erro ao salvar automação", "error");
        console.error(error);
      } finally {
        this.loadingCreate = false;
      }
    },

    editarAutomacao(item) {
      const templateParams = this.normalizarTemplateParams(item.templateParams);

      this.isHydratingAutomacao = true;
      this.modeEdit = true;
      this.automacao = {
        id: item.id,
        dataInicio: item.dataInicio,
        horario: item.horario,
        tipo: item.tipo,
        empresa: item.empresa,
        status: item.status,
      };
      this.localSelectedDateISO = this.convertToISO(item.dataInicio);
      this.selectedTemplate = null;
      this.selectedTemplateId = item.templateId || null;
      this.selectedTemplateNome = item.templateNome || null;
      this.templateParams = templateParams;
      this.templateParamLabels = [];

      this.sincronizarTemplateSelecionado({
        templateId: item.templateId,
        templateNome: item.templateNome,
        templateParams,
      });
      this.$nextTick(() => {
        this.isHydratingAutomacao = false;
      });

      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    convertToISO(dateStr) {
      if (!dateStr) return null;
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month}-${day}`;
    },

    async alterarStatus(item) {
      try {
        const novoStatus = !item.status;
        await MensageriaService.alterarStatus(item.id);

        this.mostrarSnackbar(
          `Automação ${novoStatus ? "ativada" : "desativada"} com sucesso!`,
          "success",
        );
        this.carregarAutomacoes();
      } catch (error) {
        this.mostrarSnackbar("Erro ao alterar status da automação", "error");
        console.error(error);
      }
    },

    async visualizarDados(item) {
      this.automacaoSelecionada = item;
      this.dialogVisualizacao = true;
      this.loadingDados = true;

      try {
        const response = await MensageriaService.listarDadosEnviados(item.id);
        this.dadosEnviados = response.data;
      } catch (error) {
        this.mostrarSnackbar("Erro ao carregar dados enviados", "error");
        console.error(error);
        this.dadosEnviados = [];
      } finally {
        this.loadingDados = false;
      }
    },

    async exportarDados() {
      try {
        const response = await MensageriaService.exportarDadosEnviados(
          this.automacaoSelecionada.id,
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `automacao_${this.automacaoSelecionada.id}_dados.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.mostrarSnackbar("Dados exportados com sucesso!", "success");
      } catch (error) {
        this.mostrarSnackbar("Erro ao exportar dados", "error");
        console.error(error);
      }
    },

    limparFormulario() {
      this.isHydratingAutomacao = false;
      this.modeEdit = false;
      this.automacao = {
        id: null,
        dataInicio: null,
        horario: null,
        tipo: null,
        empresa: null,
        status: true,
      };
      this.localSelectedDateISO = null;
      this.selectedTemplate = null;
      this.selectedTemplateId = null;
      this.selectedTemplateNome = null;
      this.templateParams = [];
      this.templateParamEmFoco = null;
      this.templateParamLabels = [];
      this.$refs.form.resetValidation();
    },

    mostrarSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.template-preview-sheet {
  background-color: #f5f5f5;
}

.template-preview-text {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

.dialog-table >>> tbody td,
.dialog-table >>> thead th {
  font-size: 12px !important;
  padding: 8px 12px !important;
}
</style>
